import React, { createContext, ReactNode, useContext, useEffect, useMemo } from "react";
import { ACCESS_DENIED } from "../lib/auth";
import { usePropertyChildrenQuery } from "../modules/property/property.hook";

export interface IPropertyChainData {
  isChain: boolean;
  children: string[];
}

export interface ChainDataProviderProps {
  propertyTicker: string;
  children: ReactNode | ((value: ChainDataValue) => ReactNode);
}

type ChainDataValue = IPropertyChainData | undefined | null;
export const ChainDataContext = createContext<ChainDataValue>(undefined);

export function ChainDataProvider({ propertyTicker, children }: ChainDataProviderProps) {
  const { data: propertyChildren, error } = usePropertyChildrenQuery(propertyTicker);

  useEffect(() => {
    if (!error) {
      return;
    }
    if (error === ACCESS_DENIED) {
      console.error("Access denied", error);
    } else {
      console.error("Error retrieving rpt", error);
    }
  }, [error]);

  const data = useMemo<ChainDataValue>(
    () =>
      propertyChildren && {
        isChain: !!propertyChildren.length,
        children: propertyChildren,
      },
    [propertyChildren]
  );

  return (
    <>
      {data === undefined}
      {data !== undefined && (
        <ChainDataContext.Provider value={data}>
          {typeof children === "function" ? children(data) : children}
        </ChainDataContext.Provider>
      )}
    </>
  );
}

export function useChainData(): ChainDataValue {
  return useContext(ChainDataContext);
}
